var _defs, _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 75 75",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n        stroke: #000;\n        stroke-miterlimit: 10;\n        stroke-width: 3px;\n      }\n    "))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 13.34,
    y: 7.5,
    width: 48.33,
    height: 60,
    rx: 5,
    ry: 5
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 32.11,
    y: 19.99,
    width: 23.02,
    height: 6.14,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 22.94,
    cy: 23.06,
    r: 3.07
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 32.11,
    y: 34.43,
    width: 23.02,
    height: 6.14,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 22.94,
    cy: 37.5,
    r: 3.07
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 32.11,
    y: 48.86,
    width: 23.02,
    height: 6.14,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 22.94,
    cy: 51.94,
    r: 3.07
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogs);
export default __webpack_public_path__ + "static/media/__Logs.2bc539d08e74a70ed0458e996ab1f364.svg";
export { ForwardRef as ReactComponent };